import { Component } from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

import * as h from 'h'

// We need a transition group since react-router will remove and add the Popout
// component depending on the url. The add/remove of the element itself means
// a simple CSS class toggle will not work.
export class PopoutTransitionContainer extends Component {
  render () {
    return h.h(CSSTransitionGroup, {
      transitionName: 'popout',
      transitionEnterTimeout: 300,
      transitionLeaveTimeout: 300
    }, this.props.children)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Popout/PopoutTransitionContainer.js